<template>
<el-container class="container-list is-vertical" style="height: 100%; width: 100%; position: fixed;">
  <top-header>
    <template slot="left">
      <div
        style="width: max-content; height:100%; display: inline-flex; align-items: center; justify-content: center;top: 0;;"
      >
        <el-breadcrumb separator-class="el-icon-arrow-right" class="white">
          <el-breadcrumb-item :to="{ path: '/teamBuying', query:{page:$route.query.frompage || 1} }">{{teamBuying.Tw.Title}}</el-breadcrumb-item>
          <el-breadcrumb-item>商品列表</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-input @keyup.enter.native="search" @input="delaySearch" style="width: 240px;" placeholder="搜尋" v-model="keyword" class="input-with-select">
        <el-button @click="search" slot="append" icon="el-icon-search"></el-button>
      </el-input>

    </template>
    <template slot="right">
      <!-- <el-button @click="$router.push({ name: 'product-list-sortable', query: routeQuery})" style="margin-right: 0;">拖曳排序</el-button> -->
      <!-- <el-button @click="exportExcel" style="margin-right: 0;">Excel匯出</el-button> -->
      <el-button @click="$router.push({ name: 'createTeamBuyingProduct', params: { teamBuyingID: teamBuying.ID }, query: routeQuery })" style="margin-right: 20px;">新增</el-button>
    </template>
  </top-header>
  <el-container>

    <left-menu/>

    <el-main v-loading="isLoading">
      <el-table :data="tableData" stripe height="calc(100% - 40px)">
        <template slot="empty">
          沒有資料
        </template>
        <el-table-column label="圖片" width="50px">
            <template slot-scope="scope">
              <img
                :src="getProductDataCoverImageURL(scope.row.Tw)"
                class="w-100"/>
            </template>
          </el-table-column>
        <el-table-column label="商品名稱">
          <template slot-scope="scope">
            {{scope.row.Tw.Name}}
          </template>
        </el-table-column>
        <!-- <el-table-column label="原價" width="100px">
          <template slot-scope="scope">
            NT${{scope.row.Tw.OriginalPrice|amountFormat}}
          </template>
        </el-table-column>
        <el-table-column label="特價" width="100px">
          <template slot-scope="scope">
            <span v-if="scope.row.Tw.Discount && isActiveIng(scope.row.Tw.Discount)">
              NT${{scope.row.Tw.Discount.Price|amountFormat}}
            </span>
          </template>
        </el-table-column> -->
        <el-table-column v-if="config.isProductInStockEnabled" label="庫存" width="60px">
          <template slot-scope="scope">
            {{scope.row.InStock}}
          </template>
        </el-table-column>
        <!-- <el-table-column label="排序" width="60px">
          <template slot-scope="scope">
            {{scope.row.SortOrder}}
          </template>
        </el-table-column> -->
        <!-- <el-table-column label="狀態" width="70px">
          <template slot-scope="scope">
            <p v-if="isPublished(scope.row.Tw)" class="deployed">發佈</p>
            <p v-else-if="isClosed(scope.row.Tw)" class="closed">下架</p>
            <p v-else-if="notReleaseYet(scope.row.Tw)" class="waiting">下架</p>
            <p v-else class="draft">下架</p>
          </template>
        </el-table-column> -->
        <!-- <el-table-column label="最後更新時間" width="170px">
          <template slot-scope="scope">
            {{scope.row.UpdatedAt | moment}}
          </template>
        </el-table-column> -->
        <el-table-column label="操作" :width="config.isProductInStockEnabled ? '210px' : '120px'">
          <template slot-scope="scope">
            <el-button
              size="mini"
              round
              @click="$router.push({ name: 'updateTeamBuyingProduct', params: { teamBuyingID: teamBuying.ID, id: scope.row.ID }, query: routeQuery})">編輯</el-button>

            <el-button
              v-if="config.isProductInStockEnabled"
              size="mini"
              round
              :ori-obj="editingInStockObj"
              @click="showInStockModal(scope.row)">庫存管理</el-button>

            <el-button
              size="mini"
              type="danger"
              icon="el-icon-delete"
              circle
              @click="askToDelete(scope.$index, scope.row)">
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        background
        layout="prev, pager, next"
        :currentPage="currentPage"
        :page-size="10"
        :total="searchedObjs.length"
        @current-change="onChangePage">
      </el-pagination>

      <product-editor-modal :isShow="isShowAddeditModal" @close="isShowAddeditModal = false" @submitted="onObjAddedited" :ori-obj="editingObj"/>
      <product-instock-modal :isShow="isShowInStockModal" @close="isShowInStockModal = false" @submitted="onStockSubmited" :ori-obj="editingInStockObj"/>

    </el-main>
  </el-container>
</el-container>
</template>

<script>
import moment from 'moment'
import LeftMenu from '@/views/components/LeftMenu.vue'
import TopHeader from '@/views/components/TopHeader.vue'
import ProductEditorModal from '@/data/product/view/editor-modal.vue'
import ProductInstockModal from '@/data/product/view/modal-instock.vue'
import Config from '@/assets/js/config.js'
// svgs
import '@/assets/svgs/index.js'
// excel
// import ExcelGenerator from '../excel'
import XLSXSaver from '@/utils/excel/xlsx-saver.js'

// mixin
import MixinLanguages from '@/utils/mixin-languages.vue'
import MixinFilters from '@/utils/filters/filter-mixin.vue'
import MixinDelaySearch from '@/utils/mixin-delaysearch.vue' // filterObjs method required
export default {
  mixins: [MixinLanguages, MixinFilters, MixinDelaySearch],
  components: {
    LeftMenu,
    TopHeader,
    ProductEditorModal,
    ProductInstockModal
  },
  data () {
    return {
      config: Config,
      tableData: [],
      currentPage: 1,
      isLoading: false,
      // 篩選
      filteringStatus: null,
      filteringDateRange: null,
      // modal
      isShowAddeditModal: false,
      editingObj: null,
      // instock
      isShowInStockModal: false,
      editingInStockObj: null
    }
  },
  computed: {
    teamBuying () {
      return this.$store.state.teamBuying.list.find(o => o.ID == this.$route.params.teamBuyingID)
    },
    dataList () {
      return this.teamBuying.Products.filter(o => o.IsActive)
    },
    routeQuery () {
      let query = {
        frompage: this.currentPage
      }
      if (this.keyword) query.keyword = this.keyword
      return query
    }
  },
  methods: {
    exportExcel () {
    //   try {
    //     let datas = this.searchedObjs
    //     let result = ExcelGenerator.generate(this, datas)

    //     var fileName = window.prompt(
    //       '請輸入匯出Excel檔之名稱',
    //       '旬果屋購物官網-商品匯出'
    //     )
    //     if (fileName === null) return // 取消
    //     if (!fileName) return window.alert('請輸入檔案名稱')
    //     XLSXSaver.saveAs(result, fileName)
    //   } catch (e) {
    //     alert('發生錯誤:' + e)
    //     window.console.error(`匯出異常`, e)
    //   }
    },
    showInStockModal (obj) {
      this.editingInStockObj = obj
      this.isShowInStockModal = true
    },
    isActiveIng (obj) {
      var now = moment(new Date())
      var started = true
      if (obj.BeginAt != null) started = now.isAfter(obj.BeginAt)
      if (!started) return false

      var finished = false
      if (obj.EndAt != null) finished = now.isAfter(moment(obj.EndAt).add(1, 'days'))
      if (finished) return false

      return true
    },
    getProductDataCoverImageURL (productData) {
      if (!productData.imagesJsonArr) productData.imagesJsonArr = JSON.parse(productData.Images)
      return (productData.imagesJsonArr[0] || {})['@1']
    },
    onObjAddedited () {
      this.searchWithoutAlertResult()
    },
    onChangePage (page) {
      this.currentPage = page
      this.tableData = this.searchedObjs.slice((page - 1) * 10, page * 10)
    },
    setFilterStatus (value) {
      this.filteringStatus = value
      this.filterObjs()
      this.tableData = this.searchedObjs.slice(0, 10)
    },
    filterObjs () {
      if (!this.keyword && !this.filteringStatus && !this.filteringDateRange) {
        this.searchedObjs = this.dataList
        return
      }

      const isObjFitKeyword = o => {
        if (!this.keyword) return true
        if (o.Tw && o.Tw.Name && o.Tw.Name.includes(this.keyword)) return true
        if (o.Cn && o.Cn.Name && o.Cn.Name.includes(this.keyword)) return true
        if (o.En && o.En.Name && o.En.Name.includes(this.keyword)) return true
        if (o.Jp && o.Jp.Name && o.Jp.Name.includes(this.keyword)) return true
        return false
      }

      const isObjFitStatus = o => {
        if (!this.filteringStatus) return true
        if (this.filteringStatus === '全部') return true
        return o.IsActive === (this.filteringStatus === '已發佈')
      }

      this.searchedObjs = this.dataList.filter(u => {
        return isObjFitKeyword(u) && isObjFitStatus(u)
      })
    },
    askToDelete (idx, obj) {
      this.$confirm(`確定刪除 「${obj.Tw.Name}」?`, '刪除確認', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteObj(obj)
      })
    },
    deleteObj (obj) {
      this.$services.product.inActivate(this, obj.ID).then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (ok) {
          let idx = this.teamBuying.Products.findIndex(
            o => o.ID === obj.ID
          )
          if (idx >= 0) this.$set(this.teamBuying.Products[idx], 'IsActive', false)
          this.filterObjs()
          this.tableData = this.searchedObjs.slice(
            (this.currentPage - 1) * 10,
            this.currentPage * 10
          )
          this.$message({
            message: `刪除成功`,
            type: 'success'
          })
        }
      }).catch(this.$handleServiceError)
    },
    isPublished (obj) {
      let closedAt = obj.CloseAt ? moment(obj.CloseAt).add(1, 'days') : null
      return obj.IsActive && (obj.ReleaseAt == null || moment(new Date()).isAfter(obj.ReleaseAt)) && (obj.CloseAt == null || moment(new Date()).isBefore(closedAt))
    },
    isClosed (obj) {
      let closedAt = obj.CloseAt ? moment(obj.CloseAt).add(1, 'days') : null
      return obj.IsActive && (obj.ReleaseAt == null || moment(new Date()).isAfter(obj.ReleaseAt)) && !(obj.CloseAt == null || moment(new Date()).isBefore(closedAt))
    },
    notReleaseYet (obj) {
      let closedAt = obj.CloseAt ? moment(obj.CloseAt).add(1, 'days') : null
      return obj.IsActive && !(obj.ReleaseAt == null || moment(new Date()).isAfter(obj.ReleaseAt)) && (obj.CloseAt == null || moment(new Date()).isBefore(closedAt))
    },
    onStockSubmited (evt) {
      let product = this.teamBuying.Products.find(o => o.ID === evt.productID)
      if (product) {
        this.$set(product, 'InStock', evt.stockCount)
      }
    }
  },
  created () {
    this.countPerPage = 10
    this.currentPage = parseInt(this.$route.query.page) || 1
    if (this.$route.query.keyword) this.keyword = this.$route.query.keyword
    const initTableData = () => {
      this.filterObjs()
      this.onChangePage(this.currentPage)
    }

    this.$services.teamBuying.get(this, this.$route.params.teamBuyingID).then(res => {
      let data = res.data.result
      let idx = this.$store.state.teamBuying.list.findIndex(o => o.ID == data.ID)
      if (idx >= 0) this.$set(this.$store.state.teamBuying.list, idx, data)
    }).then(initTableData).catch(this.$handleServiceError)
  }
}
</script>

<style>
.draft {
  color: #666;
  font-weight: 300;
}
.deployed {
  color: #60af4d;
  font-weight: 700;
}
.waiting {
  color: rgb(0, 149, 175);
  font-weight: 700;
}
.closed {
  color: #2a2a2a;
}
</style>
